module.exports = __webpack_public_path__ + "img/crown3.6d745d98.svg";